import { DatePicker, FormField } from '@ntconsult/aluma-react';

type DateRangeFieldProps = {
  startDate: Date | null;
  endDate: Date | null;
  onChange: (startDate: Date | null, endDate: Date | null) => void;
  startLabel: string;
  endLabel: string;
  hint?: string;
  maxDays?: number;
};

const shift = (date: Date, days: number) => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};

export function DateRangeField({
  startDate,
  endDate,
  onChange,
  startLabel,
  endLabel,
  hint,
  maxDays,
}: DateRangeFieldProps) {
  const span = maxDays === undefined ? undefined : maxDays - 1;
  return (
    <div className="flex flex-wrap items-start gap-3">
      <FormField label={startLabel} hint={hint} className="w-44">
        <DatePicker value={startDate} onChange={(value) => onChange(value, endDate)} />
      </FormField>
      <FormField label={endLabel} className="w-44">
        <DatePicker
          value={endDate}
          onChange={(value) => onChange(startDate, value)}
          minDate={startDate ?? undefined}
          maxDate={startDate && span !== undefined ? shift(startDate, span) : undefined}
        />
      </FormField>
    </div>
  );
}
